module.exports = __webpack_public_path__ + "media/images/partners/rolls-royce-b976db9176b1320a05fbce0f6b0c9c90.svg";